<form [formGroup]="form" (ngSubmit)="onSave()">
	@if (httpError) {
	<mat-error class="top-right-absolute-error-message">{{ 'masterdata.cutting.dialog.httperror' | translate }}</mat-error>
	}

	<h1 mat-dialog-title class="notification-title">{{ 'masterdata.cutting.setup' | translate }}</h1>

	<mat-dialog-content style="padding-top: 20px">
		<mat-form-field appearance="outline" class="dialog">
			@if (controls['name'].invalid && controls['name'].touched) {
			<mat-error>{{ 'masterdata.cutting.dialog.name.errors.empty' | translate }}</mat-error>
			}
			<mat-label class="mat-body-1">{{ 'masterdata.cutting.dialog.name.label' | translate }}</mat-label>
			<input maxlength="50" matInput formControlName="name" />
		</mat-form-field>

		<mat-form-field appearance="outline" class="dialog">
			<mat-label class="mat-body-1">{{ 'masterdata.cutting.description' | translate }}</mat-label>
			<input maxlength="100" matInput formControlName="description" />
		</mat-form-field>

		<div class="dialog-container">
			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">{{ 'masterdata.cutting.dialog.length.minimum' | translate }}</mat-label>
				@if (controls['minLength'].invalid && controls['minLength'].touched) {
				<mat-error>{{ 'masterdata.cutting.dialog.length.limit-error' | translate }}</mat-error>
				}
				<input OnlyNumbers matInput formControlName="minLength" />
			</mat-form-field>

			<div class="spacer"></div>
			<!-- Add white space here -->

			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">{{ 'masterdata.cutting.dialog.length.maximum' | translate }}</mat-label>
				@if (controls['maxLength'].invalid && controls['maxLength'].touched) {
				<mat-error>{{ 'masterdata.cutting.dialog.length.limit-error' | translate }}</mat-error>
				}
				<input OnlyNumbers matInput formControlName="maxLength" />
			</mat-form-field>
		</div>

		<div class="dialog-container">
			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">{{ 'masterdata.cutting.dialog.kerf.label' | translate }}</mat-label>
				@if (controls['kerf'].invalid && controls['kerf'].touched) {
				<mat-error>{{ 'masterdata.cutting.dialog.kerf.limit-error' | translate }}</mat-error>
				}
				<input OnlyNumbers matInput formControlName="kerf" />
			</mat-form-field>

			<div class="spacer"></div>
			<!-- Add white space here -->

			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">{{ 'masterdata.cutting.dialog.clearance.label' | translate }}</mat-label>
				@if (controls['clearance'].invalid && controls['clearance'].touched) {
				<mat-error>{{ 'masterdata.cutting.dialog.clearance.limit-error' | translate }}</mat-error>
				}
				<input OnlyNumbers maxlength="255" matInput formControlName="clearance" />
			</mat-form-field>

			<div class="spacer"></div>
			<!-- Add white space here -->

			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">{{ 'masterdata.cutting.dialog.rear.label' | translate }}</mat-label>
				@if (controls['rear'].invalid && controls['rear'].touched) {
				<mat-error>{{ 'masterdata.cutting.dialog.length.limit-error' | translate }}</mat-error>
				}
				<input OnlyNumbers maxlength="255" matInput formControlName="rear" />
			</mat-form-field>
		</div>

		<div class="dialog-container">
			<mat-form-field appearance="outline" class="dialog">
				@if (controls['cuttingMethod'].invalid && controls['cuttingMethod'].touched) {
				<mat-error>{{ 'masterdata.cutting.dialog.cutting-method.errors.empty' | translate }}</mat-error>
				}
				<mat-label class="mat-body-1">{{ 'masterdata.cutting.dialog.cutting-method.label' | translate }}</mat-label>
				<mat-select formControlName="cuttingMethod">
					<mat-option [value]="null">{{ 'masterdata.cutting.dialog.none' | translate }}</mat-option>
					@for (method of cuttingMethodTranslations; track method) {
					<mat-option [value]="getLastSegment(method.type.self)">{{ ('masterdata.cutting.cutting-options.method.' + getLastSegment(method.type.self)) | translate }}</mat-option>
					}
				</mat-select>
			</mat-form-field>

			<div class="spacer"></div>
			<!-- Add white space here -->

			<mat-form-field appearance="outline" class="dialog">
				@if (controls['sortingStrategy'].invalid && controls['sortingStrategy'].touched) {
				<mat-error>{{ 'masterdata.cutting.dialog.sorting-strategy.errors.empty' | translate }}</mat-error>
				}
				<mat-label class="mat-body-1">{{ 'masterdata.cutting.dialog.sorting-strategy.label' | translate }}</mat-label>
				<mat-select formControlName="sortingStrategy">
					<mat-option [value]="null">{{ 'masterdata.cutting.dialog.none' | translate }}</mat-option>
					@for (strategy of sortingStrategyTranslation; track strategy) {
					<mat-option [value]="getLastSegment(strategy.type.self)">{{ ('masterdata.cutting.sorting.strategy.' + getLastSegment(strategy.type.self)) | translate }}</mat-option>
					}
				</mat-select>
			</mat-form-field>
		</div>
	</mat-dialog-content>

	<mat-dialog-actions align="end">
		<button mat-stroked-button type="button" (click)="onCancel()" (window:keyup.escape)="onCancel()" class="button-border-color">{{ 'masterdata.cutting.dialog.cancel' | translate }}</button>
		<button mat-flat-button color="primary" type="submit" [disabled]="loading || form.invalid" [ngClass]="{ 'disabled-button': loading }">{{ 'masterdata.cutting.dialog.ok' | translate }}</button>
	</mat-dialog-actions>
</form>
